import { render, staticRenderFns } from "./TimeTheoremShop.vue?vue&type=template&id=46d9db85&scoped=true&"
import script from "./TimeTheoremShop.vue?vue&type=script&lang=js&"
export * from "./TimeTheoremShop.vue?vue&type=script&lang=js&"
import style0 from "./TimeTheoremShop.vue?vue&type=style&index=0&id=46d9db85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d9db85",
  null
  
)

export default component.exports